import appointment_img from './appointment_img.png'
import header_img from './header_img.png'
import group_profiles from './group_profiles.png'
import profile_pic from './profile_pic.png'
import dropdown_icon from './dropdown_icon.svg'
import menu_icon from './menu_icon.svg'
import cross_icon from './cross_icon.png'
import chats_icon from './chats_icon.svg'
import verified_icon from './verified_icon.svg'
import arrow_icon from './arrow_icon.svg'
import info_icon from './info_icon.svg'
import upload_icon from './upload_icon.png'
import stripe_logo from './stripe_logo.png'
import razorpay_logo from './razorpay_logo.png'
import Finance_icon from './Finance_icon.svg'
import Business_icon from './Business_icon.svg'
import label_icon from './label_icon.png'
import Photography_icon from './label_icon.png'
import Office_productivity_icon from './Office_productivity_icon.png'
import Personal_Development_icon from './Personal_Development_icon.png'
import Lifestyle_icon from './Lifestyle_icon.png'
import Music_icon from './Music_icon.png'
import Marketing_icon from './Marketing_icon.png'


import BecomeInstructor from './Become an Instructor-leftside.png'
import Digital_Marketing from './Digital_Marketing.png'
import Web_Development from './Web_Development.png'
import Marketing from './Marketing.png'
import MachineLearning from './Machine_Learning.png'
import Health from './HEALTH&FITNESS.png'
import Music from './MUSIC.png'
import DESIGN from './DESIGN.png'
import BUSINESS from './BUSINESS.png'
import LIFESTYLE from './LIFESTYLE.png'
import InstuctorImage from './InstuctorImage.png'
import Instructor1 from './Instructor1.png'
import Instructor2 from './Instructor2.png'
import Instructor3 from './Instructor3.png'
import Instructor4 from './Instructor4.png'
import Instructor5 from './Instructor5.png'
import Branches from './Branches.png'
import Branches2 from './Branches2.png'
import Branches3 from './Branches3.png'
import Branches4 from './Branches4.png'
import signature from './signature.jpg'
import seal from './seal.jpeg'

import netflixLogo from './netflix.png';
import youtubeLogo from './youtube.png';
import googleLogo from './google.png';
import lenovoLogo from './lenovo.png';
import slackLogo from './slack.png';
import verizonLogo from './verizon.png';
import lexmarkLogo from './lexmark.png';
import microsoftLogo from './microsoft.png';
import logo from './GraduationCap.png'
import FlyingLogo from './Flying Mortarboard.png'
import aboutSectionImage from './aboutSectionImage.png'
import MissionSectionImage from './MissionSection.png'

export const assets = {
    appointment_img,
    header_img,
    group_profiles,
    chats_icon,
    verified_icon,
    info_icon,
    profile_pic,
    arrow_icon,
    menu_icon,
    cross_icon,
    dropdown_icon,
    upload_icon,
    stripe_logo,
    razorpay_logo,
    Finance_icon,
    Business_icon,
    label_icon,
    Photography_icon,
    Office_productivity_icon,
    Personal_Development_icon,
    Lifestyle_icon,
    Music_icon,
    Marketing_icon,
    Digital_Marketing,
    Web_Development,
    Music,
    Health,
    MachineLearning,
    Marketing,
    BUSINESS,
    DESIGN,
    LIFESTYLE,
    BecomeInstructor,
    InstuctorImage,
    Instructor1,
    Instructor2,
    Instructor3,
    Instructor4,
    Instructor5,
    microsoftLogo,
    lexmarkLogo,verizonLogo,
    slackLogo,
    googleLogo,
    youtubeLogo,
    netflixLogo,
    lenovoLogo,
    logo,
    FlyingLogo,
    aboutSectionImage,
    MissionSectionImage,
    Branches,
    Branches2,
    Branches3,
    Branches4,
    signature,
    seal
}

